<template>
  <!--Legende -->
  <div
    class="z-50 p-0 transition-all duration-500 rounded-l-none shadow-lg  bg-base-100 card"
    :class="{
      'translate-x-[calc(-100%+2rem)] h-40 ': !openLegend,
      'translate-x-0 ': openLegend,
    }"
  >
    <div
      :class="{
        'opacity-0 pointer-events-none': openLegend,
        'opacity-100 pointer-events-auto': !openLegend,
      }"
      @click="openLegend = !openLegend"
      class="absolute right-0 flex items-center justify-between h-full py-4 text-2xl font-bold rotate-180  text-secondary-content bg-secondary"
      style="writing-mode: vertical-rl; text-orientation: mixed"
    >
      <span>Acteurs</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-6 scale-100 rotate-90 cursor-pointer  animate-pulse hover:scale-110 hover:animate-none"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
        />
      </svg>
    </div>
    <div class="p-0 card-body">
      <div
        :class="{
          'opacity-0 hid': !openLegend,
          'opacity-100': openLegend,
        }"
        @click="openLegend = !openLegend"
        class="flex items-center justify-between px-2 py-1 text-2xl font-bold  gap-x-4 card-title bg-secondary text-secondary-content"
      >
        <span>Liste des acteurs</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-6 h-6 scale-100 rotate-90 cursor-pointer  animate-pulse hover:scale-110 hover:animate-none"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M19 13l-7 7-7-7m14-8l-7 7-7-7"
          />
        </svg>
      </div>

      <div
        class="px-2 overflow-auto max-h-64"
        :class="{
          hidden: !openLegend,
          block: openLegend,
        }"
      >
        <template v-for="(result, index) in items" :key="index">
          <div
            @mouseover="$emit('itemhover', result)"
            @mouseleave="$emit('itemrelease')"
            class="p-2 mt-1 mb-2 border-l-4 cursor-pointer  rounded-l-xl hover:font-bold hover:border-l-8 ring-1 animate__animated animate__fadeInDown"
            :class="{
              '!border-1-non-institutionelle !text-1-non-institutionelle':
                result.type.id == 1,
              '!border-2-institutionelle   !text-2-institutionelle':
                result.type.id == 2,
              '!border-3-financier !text-3-financier': result.type.id == 3,
            }"
          >
            <span>{{ result.abbreviation }}</span>
          </div>
        </template>
      </div>
    </div>
  </div>
  <!-- Fin  Legende -->
</template>

<script>
export default {
  name: "ListeActeur",
  props: {
    items: Array,
  },
  data() {
    return {
      openLegend: true,
    };
  },
};
</script>

<style>
</style>
